export const ECOM_PLATFORM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
export const conductorSpecs = {};
export const SPECS = {
  ...conductorSpecs
};
//# sourceMappingURL=consts.js.map